import { render, staticRenderFns } from "./tabs-body.vue?vue&type=template&id=15bf7e84&scoped=true&"
import script from "./tabs-body.vue?vue&type=script&lang=js&"
export * from "./tabs-body.vue?vue&type=script&lang=js&"
import style0 from "./tabs-body.vue?vue&type=style&index=0&id=15bf7e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf7e84",
  null
  
)

export default component.exports